/* SMD Motor Finder entry points.
   Any element with data-smd-mf opens the site-wide Motor Finder popup.
   data-smd-mf="roller" (or drapery, cellular, tilt, exterior, awning, pergola,
   replace) answers the first question for the reader. An empty value just
   opens the finder. Drives the existing popup through its own buttons, so
   assets/smd-motor-finder-ui.js stays untouched. */
(function () {
  'use strict';
  if (window.__smdMfEntry) return;
  window.__smdMfEntry = true;

  function chipFor(input, label) {
    var bs = input.querySelectorAll('.mf-chip');
    for (var i = 0; i < bs.length; i++) {
      var t = bs[i].firstChild ? bs[i].firstChild.textContent : bs[i].textContent;
      if (String(t).trim() === label) return bs[i];
    }
    return null;
  }

  function go(cat) {
    var root = document.getElementById('smd-mf');
    if (!root) return false;
    var panel = root.querySelector('.smd-mf-panel');
    var launch = root.querySelector('.smd-mf-launch');
    var input = root.querySelector('.smd-mf-input');
    var log = root.querySelector('.smd-mf-log');
    var A = window.SMDMotorFinder || {};
    var c = (A.CATS || []).filter(function (x) { return x.id === cat; })[0];
    var fresh = !log.querySelector('.mf-msg');

    if (panel.hidden && launch) launch.click();
    if (!c) return true;
    if (!fresh) {
      var restart = root.querySelector('[data-mf-restart]');
      if (restart) restart.click();
    }
    var t0 = Date.now();
    (function wait() {
      var b = chipFor(input, c.label);
      if (b) { b.click(); return; }
      if (Date.now() - t0 < 5000) setTimeout(wait, 80);
    })();
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-smd-mf]') : null;
    if (!t) return;
    e.preventDefault();
    go(t.getAttribute('data-smd-mf') || '');
  });

  window.SMDMotorFinderOpen = go;
})();
